import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {DateTimePickerModule} from "@syncfusion/ej2-angular-calendars";

@Component({
    selector: 'app-form-date-time',
    imports: [
        ReactiveFormsModule,
        DateTimePickerModule
    ],
    templateUrl: './form-date-time.component.html',
    styleUrl: './form-date-time.component.scss'
})
export class FormDateTimeComponent implements OnChanges {

  @Input() public fCN: string = '';
  @Input() public disabled: boolean = false;
  @Input() public cssClass: string = '';
  @Input() public placeholder: string = '';
  @Input() public fG: FormGroup = new FormGroup({});
  @Input() public step: number = 15;
  @Input() public format: string | undefined = undefined;
  @Input() public min: Date | null = null;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled'] && this.fG.controls[this.fCN]) {
      if (this.disabled) {
        this.fG.controls[this.fCN].disable();
      } else {
        this.fG.controls[this.fCN].enable();
      }
    }
  }
}
